module.exports = __webpack_public_path__ + "static/media/David Glennon.21e55045.jpg";